import clsx from 'clsx';
import React from 'react';
import type { Placement } from '@floating-ui/react';

import { Tooltip } from '../../Tooltip/Tooltip';
import { Button } from '../BaseButton/Button';

type PrimaryButtonV2Props = Omit<
  JSX.IntrinsicElements['button'],
  'background' | 'fontDecoration' | 'extraClassNames' | 'color'
> & {
  secondaryIcon?: React.ReactNode;
  tooltipText?: string;
  tooltipPlacement?: Placement;
};

export const PrimaryButtonV2 = ({
  onClick,
  disabled = false,
  children,
  className,
  secondaryIcon,
  type = 'button',
  tooltipText,
  tooltipPlacement = 'top-start',
  ...props
}: PrimaryButtonV2Props): JSX.Element => (
  <Tooltip
    baseComponent={
      <Button
        type={type}
        onClick={onClick}
        disabled={disabled}
        extraClassNames={clsx(
          'hover:enabled:cursor-pointer hover:disabled:cursor-not-allowed h-min focus:outline-none',
          className
        )}
        background="disabled:bg-main-200 bg-main hover:enabled:bg-negative"
        fontDecoration="no-underline"
        color="disabled:text-main-500 text-negative hover:text-main"
        {...props}
      >
        {children}
        {secondaryIcon && (
          <span className="text-main-500">{secondaryIcon}</span>
        )}
      </Button>
    }
    tooltipComponent={<span className="text-main">{tooltipText}</span>}
    tooltipDisabled={!tooltipText}
    padding="p-f0"
    delayShow={500}
    placement={tooltipPlacement}
  />
);
